import React, { Component } from 'react'

import Font from '../../atoms/Font'
import ImageContent from '../../atoms/ImageContent'
import Rating from '../../atoms/Rating'

import T from '../../translate/T'
import { Config } from '../../_config'

import style from './style.css'

class FeaturedEvents extends Component {
    render(){
        
        return(
            <div className={`${style.wrapfeatured}`}>
                <ImageContent image={`${Config.imgExperience}${this.props.cover}`}>
                    <Rating label={T.txt('difficulty')} exp={this.props.exp} />
                    <Font size="24px" weight="100" color="white" style={{margin: '20px 0'}}>{this.props.name}</Font><br />
                    <Font size="14px" weight="100" color="white" style={{fontStyle: 'italic'}}>{this.props.price}</Font>
                </ImageContent>
            </div>
        )
    }
}

export default FeaturedEvents


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/molecules/FeaturedEvents/index.js